import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import { getFreightModeIcon } from "helpers/freightModeHelper";
import CardItem from "./CardItem";

interface IFreightModeCardProps {
  freightModes: any[];
}

function FreightModeCard({ freightModes }: IFreightModeCardProps) {
  return (
    <CardItem>
      <p className="font-b3 text-secondary mb-2">
        <FormattedMessage id="general.freightMode" defaultMessage="Freight Mode" />
      </p>
      <p>
        {freightModes?.length > 0
          ? freightModes.map((freightMode: any) => {
              const Icon = getFreightModeIcon(freightMode.label, freightMode.type, true);
              return (
                <OverlayTrigger
                  placement="top"
                  key={freightMode.value}
                  overlay={
                    <Tooltip id="freight-mode" style={{ zIndex: 999999 }}>
                      <span className="font-weight-normal">{freightMode.label}</span>
                    </Tooltip>
                  }
                >
                  {Icon && <Icon />}
                </OverlayTrigger>
              );
            })
          : "-"}
      </p>
    </CardItem>
  );
}

export default FreightModeCard;
